const KEY = 'recent_ads_v1';
const MAX = 12;

function getCookie(name) {
    const parts = document.cookie.split(';').map(v => v.trim());
    const found = parts.find(v => v.startsWith(name + '='));
    return found ? decodeURIComponent(found.split('=').slice(1).join('=')) : '';
}

function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

function readIds() {
    try {
        const raw = getCookie(KEY);
        if (!raw) return [];
        return raw.split(',')
            .map(v => parseInt(v, 10))
            .filter(n => Number.isFinite(n) && n > 0);
    } catch {
        return [];
    }
}

function pushId(id) {
    const adId = parseInt(id, 10);
    if (!Number.isFinite(adId) || adId <= 0) return;

    const ids = readIds();
    const next = [adId, ...ids.filter(x => x !== adId)].slice(0, MAX);

    setCookie(KEY, next.join(','), 30); // 30 gün
}

document.addEventListener('DOMContentLoaded', () => {
    const meta = document.getElementById('ad-detail-meta');
    const adId = meta?.dataset?.adId;
    if (adId) pushId(adId);
});
